import { combineReducers } from '@reduxjs/toolkit';
import { BASKET_API_REDUCER_KEY, basketApi } from './api/basket';
import sidebarSlice from './slices/sidebarSlice';
const rootReducer = combineReducers({
    [BASKET_API_REDUCER_KEY]: basketApi.reducer,
    sidebar: sidebarSlice
});
export default rootReducer;
